import { FC } from 'react';
import FareSummary from '../FareSummary';
import { FareSummaryProps } from '../FareSummary/index.types';
import MessageBubble from '../MessageBubble';
import { WidgetProps } from './index.types';

const RefundEstimate: FC<Omit<WidgetProps, 'isLastMessage'>> = ({ message, widgetData }) => {
    const { actor } = message;
    const data = widgetData.parameters.data as FareSummaryProps['data'];

    return (
        <MessageBubble actor={actor} className='w-full max-w-md'>
            <FareSummary data={data} />
        </MessageBubble>
    );
};

export default RefundEstimate;
